// extracted by mini-css-extract-plugin
export default {"pageNotFound":"PageNotFound_pageNotFound__Gt2TE","link":"PageNotFound_link__6PojN"};